var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.7071L14.2929 1L12.5771 2.71585C11.3485 1.6502 9.75025 1 8 1C4.14015 1 1 4.14015 1 8C1 9.75025 1.6502 11.3485 2.71585 12.5771L1 14.2929L1.7071 15L3.42295 13.2842C4.65155 14.3498 6.24975 15 8 15C11.8598 15 15 11.8598 15 8C15 6.24975 14.3498 4.65155 13.2842 3.42295L15 1.7071ZM2 8C2 4.69165 4.69165 2 8 2C9.4746 2 10.8245 2.53695 11.8703 3.4226L3.4226 11.8703C2.53695 10.8245 2 9.4746 2 8ZM14 8C14 11.3086 11.3086 14 8 14C6.52545 14 5.17555 13.463 4.12975 12.5773L12.5773 4.12975C13.463 5.17555 14 6.52545 14 8Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipNone);
export default __webpack_public_path__ + "static/media/ic-chip-none.f5556adcadb926a43962f7399b977584.svg";
export { ForwardRef as ReactComponent };